export default "__VITE_ASSET__5fdf9947__"